import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

export const initialState = {
  model: {
    considerationOptions: [],
    skuList: [],
  },
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
};

const polishSku = createSlice({
  name: 'polishSku',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    success: (state, action) => {
      const result = action.payload.result || {};
      state.meta.status = STATUS.SUCCESS;
      state.meta.count = result.count;
      state.meta.next = result.next;
      state.meta.previous = result.previous;
      state.model.considerationOptions = result.considerationOptions;
      state.model.entityJurisdictionId = result.entityJurisdictionId;
      state.model.skuList = result.skuList;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    updateRequest: state => {
      state.meta.status = STATUS.LOADING;
    },
    updateFailure: state => {
      state.meta.status = STATUS.SUCCESS;
    },
    deleteAllRequest: state => {
      state.meta.status = STATUS.LOADING;
    },
    deleteAllFailure: state => {
      state.meta.status = STATUS.SUCCESS;
    },
    downloadTemplateRequest: state => {
      state.meta.isDownloadingTemplate = true;
    },
    downloadTemplateComplete: state => {
      state.meta.isDownloadingTemplate = false;
    },
    uploadTemplateRequest: state => {
      state.meta.status = STATUS.LOADING;
    },
    uploadTemplateComplete: state => {
      state.meta.status = STATUS.SUCCESS;
    },
  },
});

export const {
  reset: polishSkuReset,
  request: polishSkuRequest,
  success: polishSkuSuccess,
  failure: polishSkuFailure,
  updateRequest: polishSkuUpdateRequest,
  updateFailure: polishSkuUpdateFailure,
  deleteAllRequest: polishSkuDeleteAllRequest,
  deleteAllFailure: polishSkuDeleteAllFailure,
  downloadTemplateRequest: polishSkuDownloadTemplateRequest,
  downloadTemplateComplete: polishSkuDownloadTemplateComplete,
  uploadTemplateRequest: polishSkuUploadTemplateRequest,
  uploadTemplateComplete: polishSkuUploadTemplateComplete,
} = polishSku.actions;

export default polishSku.reducer;
